import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import SupplementQuery from './pages/SupplementQuery';
import StackChecker from './pages/StackChecker';
import RecallTracker from './pages/RecallTracker';
import LearnGuide from './pages/LearnGuide';
import OurStory from './pages/OurStory';
import DonatePage from './pages/DonatePage';

function BottomNav() {
  const location = useLocation();
  const tabs = [
    { path: '/', label: 'Search', icon: '🔍' },
    { path: '/stack', label: 'Stack', icon: '⚖️' },
    { path: '/recalls', label: 'Recalls', icon: '🚨' },
    { path: '/learn', label: 'Learn', icon: '📖' },
    { path: '/story', label: 'Story', icon: '🐾' },
    { path: '/donate', label: 'Donate', icon: '💛' },
  ];

  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000,
      background: 'linear-gradient(180deg, #0c1624 0%, #0a1220 100%)',
      borderTop: '2px solid rgba(56,189,248,0.2)',
      display: 'flex', justifyContent: 'space-around', alignItems: 'center',
      padding: '8px 4px',
      paddingBottom: 'max(10px, env(safe-area-inset-bottom))',
      boxShadow: '0 -4px 20px rgba(0,0,0,0.5)',
    }}>
      {tabs.map(tab => {
        const isActive = location.pathname === tab.path;
        return (
          <NavLink key={tab.path} to={tab.path} style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            textDecoration: 'none', padding: '4px 6px', minWidth: 50,
            color: isActive ? '#38bdf8' : '#8ba4b8',
            transition: 'color 0.15s',
            position: 'relative',
          }}>
            {isActive && <div style={{
              position: 'absolute', top: -10, left: '50%', transform: 'translateX(-50%)',
              width: 32, height: 3, borderRadius: 2,
              background: '#38bdf8',
            }} />}
            <span style={{ fontSize: 22, lineHeight: 1 }}>{tab.icon}</span>
            <span style={{
              fontSize: 11, marginTop: 3,
              fontWeight: isActive ? 700 : 500,
              fontFamily: "'Segoe UI', system-ui, sans-serif",
              color: isActive ? '#7dd3fc' : '#5a7a90',
              letterSpacing: '0.02em',
            }}>{tab.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div style={{ paddingBottom: 80 }}>
        <Routes>
          <Route path="/" element={<SupplementQuery />} />
          <Route path="/stack" element={<StackChecker />} />
          <Route path="/recalls" element={<RecallTracker />} />
          <Route path="/learn" element={<LearnGuide />} />
          <Route path="/story" element={<OurStory />} />
          <Route path="/donate" element={<DonatePage />} />
        </Routes>
      </div>
      <BottomNav />
    </BrowserRouter>
  );
}
